'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _strftime = require('strftime');

var _strftime2 = _interopRequireDefault(_strftime);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _batchedAdd = require('../batchedAdd');

var _batchedAdd2 = _interopRequireDefault(_batchedAdd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nextBufferId = 0;

var BufferState = function () {
    function BufferState(name, networkid, state, messageDict) {
        (0, _classCallCheck3.default)(this, BufferState);

        this.id = nextBufferId++;
        this.networkid = networkid;
        this.name = name;
        this.topic = '';
        this.key = '';
        this.joined = false;
        this.enabled = true;
        this.users = (0, _create2.default)(null);
        this.modes = (0, _create2.default)(null);
        this.flags = {
            unread: 0,
            alert_on: 'default',
            has_opened: false,
            channel_badkey: false,
            chathistory_available: true,
            requested_modes: false
        };
        this.settings = {};
        this.last_read = 0;
        this.active_timeout = null;
        this.message_count = 0;
        this.current_input = '';

        def(this, 'state', state, false);
        def(this, 'messageDict', messageDict, false);

        var messagesObj = {
            networkid: this.networkid,
            buffer: this.name,
            messages: []
        };
        this.messageDict.push(messagesObj);
        def(this, 'messagesObj', messagesObj, false);
    }

    (0, _createClass3.default)(BufferState, [{
        key: 'getNetwork',
        value: function getNetwork() {
            return this.state.getNetwork(this.networkid);
        }
    }, {
        key: 'getMessages',
        value: function getMessages() {
            var bufMessages = _lodash2.default.find(this.messageDict, {
                networkid: this.networkid,
                buffer: this.name
            });

            return bufMessages ? bufMessages.messages : [];
        }
    }, {
        key: 'isServer',
        value: function isServer() {
            return this.name === '*';
        }
    }, {
        key: 'isChannel',
        value: function isChannel() {
            var chanPrefixes = ['#', '&'];
            var ircNetwork = this.getNetwork().ircClient.network;
            if (ircNetwork && ircNetwork.options.CHANTYPES) {
                chanPrefixes = ircNetwork.options.CHANTYPES;
            }

            return chanPrefixes.indexOf(this.name[0]) > -1;
        }
    }, {
        key: 'isQuery',
        value: function isQuery() {
            var chanPrefixes = ['#', '&'];
            var ircNetwork = this.getNetwork().ircClient.network;
            if (ircNetwork && ircNetwork.options.CHANTYPES) {
                chanPrefixes = ircNetwork.options.CHANTYPES;
            }

            return chanPrefixes.indexOf(this.name[0]) === -1 && !this.isSpecial() && !this.isServer();
        }
    }, {
        key: 'isSpecial',
        value: function isSpecial() {
            var name = this.name;
            return name[0] === '*' && name.length > 1;
        }
    }, {
        key: 'isUserAnOp',
        value: function isUserAnOp(nick) {
            var user = this.state.getUser(this.networkid, this.getNetwork().nick);
            if (!user) {
                return false;
            }

            var userBufferInfo = user.buffers[this.id];
            if (!userBufferInfo) {
                return false;
            }

            var modes = userBufferInfo.modes;
            var opModes = ['Y', 'y', 'q', 'a', 'o', 'h'];
            var hasOp = _lodash2.default.find(modes, function (mode) {
                return opModes.indexOf(mode.toLowerCase()) > -1;
            });

            return !!hasOp;
        }
    }, {
        key: 'setting',
        value: function setting(name, val) {
            if (typeof val !== 'undefined') {
                this.state.$set(this.settings, name, val);
                return val;
            }

            var result = typeof this.settings[name] !== 'undefined' ? this.settings[name] : this.state.setting('buffers.' + name);

            return result;
        }
    }, {
        key: 'rename',
        value: function rename(newName) {
            var network = this.getNetwork();
            var oldName = this.name;
            var setActive = this.state.getActiveBuffer() === this;

            this.name = newName;
            if (setActive) {
                this.state.setActiveBuffer(network.id, newName);
            }

            var bufferMessages = _lodash2.default.find(this.messageDict, { networkid: network.id, buffer: oldName });
            bufferMessages.buffer = newName;
        }
    }, {
        key: 'flag',
        value: function flag(name, val) {
            if (typeof val !== 'undefined') {
                this.state.$set(this.flags, name, val);
                return val;
            }

            return this.flags[name];
        }
    }, {
        key: 'requestScrollback',
        value: function requestScrollback(_direction) {
            var _this = this;

            var direction = _direction || 'backward';
            var time = '';

            var numMessages = -50;

            if (direction === 'backward') {
                var lastMessage = this.getMessages().reduce(function (earliest, current) {
                    var validType = earliest.type !== 'traffic';
                    if (validType && earliest.time && earliest.time < current.time) {
                        return earliest;
                    }
                    return current;
                }, this.getMessages()[0]);

                numMessages = -50;
                time = lastMessage ? new Date(lastMessage.time) : new Date();
            } else if (direction === 'forward') {
                var firstMessage = this.getMessages().reduce(function (latest, current) {
                    var validType = latest.type !== 'traffic';
                    if (validType && latest.time && latest.time > current.time) {
                        return latest;
                    }
                    return current;
                }, this.getMessages()[0]);

                numMessages = 50;
                time = firstMessage ? new Date(firstMessage.time) : new Date();
            } else {
                throw new Error('Invalid direction for requestScrollback(): ' + _direction);
            }

            var irc = this.getNetwork().ircClient;
            var timeStr = (0, _strftime2.default)('%FT%T.%L%:z', time);
            irc.raw('CHATHISTORY ' + this.name + ' timestamp=' + timeStr + ' message_count=' + numMessages);
            irc.once('batch end chathistory', function (event) {
                if (event.commands.length === 0) {
                    _this.flags.chathistory_available = false;
                } else {
                    _this.flags.chathistory_available = true;
                }
            });
        }
    }, {
        key: 'markAsRead',
        value: function markAsRead(delayed) {
            if (this.active_timeout) {
                clearTimeout(this.active_timeout);
                this.active_timeout = null;
            }
            if (delayed) {
                this.active_timeout = setTimeout(this.markAsRead.bind(this), 10000, false);
            } else {
                this.last_read = Date.now();
                this.flag('highlight', false);

                var network = this.getNetwork();
                var allowedUpdate = !network ? false : this.isChannel() || this.isQuery();
                if (allowedUpdate && network.connection.bncname) {
                    var lastMessage = this.getMessages().reduce(function (latest, current) {
                        if (latest.time && latest.time > current.time) {
                            return latest;
                        }
                        return current;
                    }, this.getMessages()[0]);

                    if (!lastMessage) {
                        return;
                    }

                    network.ircClient.bnc.bufferSeen(network.connection.bncname, this.name, new Date(lastMessage.time));
                }
            }
        }
    }, {
        key: 'incrementFlag',
        value: function incrementFlag(flagName) {
            this.flags[flagName] = (this.flags[flagName] || 0) + 1;
        }
    }, {
        key: 'addUser',
        value: function addUser(user) {
            var _this2 = this;

            if (!this.addUserBatch) {
                var addSingleUser = function addSingleUser(u) {
                    _this2.state.$set(_this2.users, u.nick.toLowerCase(), u);
                };
                var addMultipleUsers = function addMultipleUsers(users) {
                    var o = _lodash2.default.clone(_this2.users);
                    users.forEach(function (u) {
                        o[u.nick.toLowerCase()] = u;
                    });
                    _this2.users = o;
                };

                def(this, 'addUserBatch', (0, _batchedAdd2.default)(addSingleUser, addMultipleUsers));
            }

            this.addUserBatch(user);
        }
    }, {
        key: 'removeUser',
        value: function removeUser(nick) {
            var userObj = this.state.getUser(this.networkid, nick);

            _lodash2.default.pull(this.addUserBatch.queue(), userObj);

            this.state.$delete(this.users, nick.toLowerCase());

            if (userObj) {
                delete userObj.buffers[this.id];
            }
        }
    }, {
        key: 'clearUsers',
        value: function clearUsers() {
            var _this3 = this;

            this.addUserBatch && this.addUserBatch.queue().splice(0);

            _lodash2.default.each(this.users, function (userObj, nick) {
                delete userObj.buffers[_this3.id];
            });

            this.state.$set(this, 'users', {});
        }
    }, {
        key: 'addMessage',
        value: function addMessage(message) {
            var _this4 = this;

            if (!this.addMessageBatch) {
                var addSingleMessage = function addSingleMessage(newMessage) {
                    _this4.messagesObj.messages.push(newMessage);
                    _trimMessages();
                    _this4.message_count++;
                };
                var addMultipleMessages = function addMultipleMessages(newMessages) {
                    _this4.messagesObj.messages = _this4.messagesObj.messages.concat(newMessages);
                    _trimMessages();
                    _this4.message_count++;
                };
                var _trimMessages = function _trimMessages() {
                    var scrollbackSize = _this4.setting('scrollback_size');
                    var length = _this4.messagesObj.messages.length;

                    if (_this4.messagesObj.messages.length > scrollbackSize) {
                        _this4.messagesObj.messages.splice(0, length - scrollbackSize);
                    }
                };

                def(this, 'addMessageBatch', (0, _batchedAdd2.default)(addSingleMessage, addMultipleMessages));
            }

            this.addMessageBatch(message);
        }
    }, {
        key: 'say',
        value: function say(message) {
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var network = this.getNetwork();
            var newMessage = {
                time: Date.now(),
                nick: network.nick,
                message: message,
                type: opts.type || 'privmsg'
            };

            this.state.addMessage(this, newMessage);

            var fnNames = {
                privmsg: 'say',
                action: 'action',
                notice: 'notice'
            };
            var fnName = fnNames[opts.type] || 'say';
            network.ircClient[fnName](this.name, message);
        }
    }, {
        key: 'join',
        value: function join() {
            if (!this.isChannel()) {
                return;
            }

            var network = this.getNetwork();
            network.ircClient.join(this.name, this.key || '');
        }
    }, {
        key: 'part',
        value: function part(reason) {
            if (!this.isChannel()) {
                return;
            }

            var network = this.getNetwork();
            network.ircClient.part(this.name, reason || '');
        }
    }]);
    return BufferState;
}();

exports.default = BufferState;

function def(target, key, value, canSet) {
    var val = value;

    var definition = {
        get: function get() {
            return val;
        }
    };

    if (canSet) {
        definition.set = function set(newVal) {
            var oldVal = val;
            val = newVal;
            if (typeof canSet === 'function') {
                canSet(newVal, oldVal);
            }
        };
    }

    (0, _defineProperty2.default)(target, key, definition);

    if (typeof canSet === 'function') {
        canSet(val);
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/libs/state/BufferState.js
// module id = FKBE
// module chunks = 1